<template>
  <div v-if="appoint" >
    <el-page-header @back="goback" content="预留待确认" > </el-page-header>
    <el-card class="box-card">
      <AppointInfo :appoint="appoint"></AppointInfo>
    </el-card>

    <p class="text-center" style="color:rgb(48, 49, 51);margin-bottom:12px;">{{diff24HourLater(appoint.planCreateTime)}}</p>
    <el-button v-if="diff24HourLater(appoint.planCreateTime)!='已过确认时间'" type="primary" round style="width: 100%" @click="confirm = true">确认</el-button>

    <p class="text-right">
      <el-link  v-if="diff24HourLater(appoint.planCreateTime)!='已过确认时间'" type="danger" @click="reminderShow = true">温馨提示</el-link>
    </p>

    <Reminder v-if="reminderShow" @close-reminder="closeReminder"></Reminder>
    <el-dialog
      title="预留确认"
      :visible.sync="confirm"
      width="100%"
      :show-close="false"
      class="confirm"
    >
      <div class="borderrd">
        <AppointText :appoint="appoint"></AppointText>
      </div>
      <div class="text borderrd">
        <ReminderText></ReminderText>
      </div>
      <span slot="footer">
        <el-button @click="confirm = false" round>取 消</el-button>
        <el-button type="primary" @click="confirmSchedule(appoint.id)" round>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HttpRequest from "@/utils/request";
import { diff24HourLater } from "@/utils/date.js";
import AppointInfo from '@/components/appointInfo'
import AppointText from '@/components/appointText'
import Reminder from '../components/reminder.vue';
import ReminderText from '../components/reminderText.vue';
export default {
  components: {
    AppointInfo,
    AppointText,
    Reminder,
    ReminderText,
  },
  data() {
    return {
      reminderShow: false,
      confirm: false,
      appoint: {},
      scheduleId: null,
      pathfrom: null,
      //
      diff24HourLater,
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  created() {
    if (this.$route.query.scheduleId) {
      this.scheduleId = this.$route.query.scheduleId;
      this.getSchedule();
    }
    else{
      this.$alert('请求url缺乏必须的参数',  {confirmButtonText: '确定',showClose: false,});
    }
    this.pathfrom = this.$route.query.pathfrom;
  },
  mounted() {
    document.title = '预约详情'
  },
  methods: {
    goback() {
      this.$router.back();
      // this.$router.push("appointView");
    },
    getSchedule(){
      let url = "/constub/getSchedule";
      let data = { token: this.student.token, scheduleId: this.scheduleId };
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.appoint = res.data;
          if(this.appoint.status != 18){  //判断状态是否正确
            this.$message({message: '预约状态已变更，跳转回原路径',type: "error",});
            this.$router.push(this.pathfrom?this.pathfrom:'home')
          }
        } else {
          this.$alert(res.result.message,  {
            confirmButtonText: '确定',
            showClose: false,
          });
        }
      });
    },
    confirmSchedule(scheduleId) {
      let url = "/constub/confirmAppoint";
      let data = { token: this.student.token, scheduleId: scheduleId };
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.appoint = res.data;
          // this.$router.push({ name: "appointWait", params: { appoint: this.appoint } });
          this.$router.push('/appointWait?scheduleId=' + scheduleId + (this.pathfrom?'&pathfrom=home':''))
        } else {
          this.$alert(res.result.message,  {
            confirmButtonText: '确定',
            showClose: false,
          });
        }
      });
    },
    closeReminder(){
      this.reminderShow = false;
    },
  },
};
</script>


<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}

.title {
  width: 100%;
  padding: 10px;
  background-color: rgb(198, 212, 248);
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}
.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}
p {
  line-height: 24px;
}
.borderrd {
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
